import React, { createContext, useContext, useState, } from 'react';
import { createHexProperties } from '@wareena/game-algorithms';
import createRules from '@wareena/grid-battles-engine/rules/index';
import { createPlayerInfo } from '../../dto/playerInfo.js';
const defaultValue = {
    game: {},
    scenario: {},
    setGame: () => { },
    hexProperties: {},
    rules: {},
    playerInfo: {},
    loggedInUserId: 0,
    wasGameOverMessageHidden: false,
    setWasGameOverMessageHidden: () => null,
    combatDetail: { isVisible: false, combatId: null },
    setCombatDetail: () => null,
};
const GameContext = createContext(defaultValue);
export function GameContextProvider({ children, initialGame, scenario, loggedInUserId, }) {
    const [game, setGame] = useState(initialGame);
    const [wasGameOverMessageHidden, setWasGameOverMessageHidden] = useState(false);
    const [combatDetail, setCombatDetail] = useState({ isVisible: false, combatId: null });
    const hexProperties = createHexProperties({
        hexSize: scenario.hexSize,
        hasFlatTop: scenario.hasFlatTop,
        hasOffsetOnFirstLine: scenario.hasOffsetOnFirstLine,
    });
    const rules = createRules(game.hexes, hexProperties);
    const playerInfo = createPlayerInfo(game, loggedInUserId);
    const contextValue = {
        game,
        setGame,
        scenario,
        hexProperties,
        rules,
        playerInfo,
        loggedInUserId,
        wasGameOverMessageHidden,
        setWasGameOverMessageHidden,
        combatDetail,
        setCombatDetail,
    };
    return React.createElement(GameContext.Provider, { value: contextValue }, children);
}
export function useGameContext() {
    const gameCtx = useContext(GameContext);
    return gameCtx;
}
export default GameContext;
